import { useI18n } from '@platform/i18n';
import { PageBody, PageHeader } from '@platform/ui';
import { CalendarSettingsPanel } from '../calendar/settings-dialog';
import { SettingsTabs } from './settings-tabs';

/** Settings > Calendar & contacts: the calendar settings of the calendar gear, as a page. */
export function CalendarSettingsPage() {
  const { t } = useI18n();
  return (
    <div className="min-h-0 flex-1 overflow-y-auto">
      <PageHeader title={t('ia.webmailAreas.calendarPage')} tabs={<SettingsTabs active="calendar" />} />
      <PageBody width="form">
        <CalendarSettingsPanel />
      </PageBody>
    </div>
  );
}
